import styled from "styled-components";
import { Button } from "@sablier/v2-components/molecules";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";

const Wrapper = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    justify-content: flex-end;
    width: 100%;
    min-height: ${(props) => props.theme.sizes.buttonMini};
    padding: calc(${(props) => props.theme.sizes.edge} * 1)
      ${(props) => props.theme.sizes.modalEdge};
    column-gap: ${(props) => props.theme.sizes.edge};
    border-top: 2px solid ${(props) => props.theme.colors.border};
    & > * {
      flex: 1;
    }
  }

  ${(props) => props.theme.medias.maxMD} {
    padding: calc(${(props) => props.theme.sizes.edge} * 1)
      calc(${(props) => props.theme.sizes.edge} * 3 / 2);
  }
  ${(props) => props.theme.medias.maxSM} {
    padding: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    & > * {
      flex: 1;
    }
  }
`;
interface Props {
  onAll: () => void;
  onConfirm: () => void;
}

export default function Footer({ onAll, onConfirm }: Props) {
  const { t } = useT();

  return (
    <Wrapper>
      <Button
        accent={"iconic"}
        appearance={"outline"}
        onClick={onAll}
        title={t("structs.acceptAll")}
      />
      <Button
        accent={"iconicPrimary"}
        appearance={"outline"}
        onClick={onConfirm}
        title={t("modalCards.permissions.action")}
        titleShort={t("words.save")}
      />
    </Wrapper>
  );
}
